// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_RESSOURCES } from "api/services/teacher/teacher.routes";

// Define a service using a base URL and expected endpoints
export const CountContentApi = createApi({
  reducerPath: "CountContentApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_RESSOURCES,
  }),

  endpoints: (builder) => ({
    getContentCount: builder.query<any, any>({
      query: (userId) => `/exercices/countContentsByUser/${userId}`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetContentCountQuery } = CountContentApi;
